{
  "auth": {
    "agree": "Souhlasím s",
    "createAccount": "Vytvořit účet",
    "createNewAccount": "Vytvořit nový účet",
    "email": "Email",
    "login": "Přihlásit se",
    "password": "Heslo",
    "forgot_password": "Zapomněli jste heslo?",
    "recover_password": "Obnovit heslo",
    "recovery_message": "Zadejte svůj email a my vám pošleme odkaz na obnovení hesla.",
    "sign_up": "Zaregistrovat se",
    "keep_logged_in": "Zůstat přihlášený",
    "termsOfUse": "Podmínky užívání.",
    "reset_password": "Obnovit heslo",
    "update_password": "Aktualizovat heslo"
  },
  "404": {
    "title": "Tato stránka je mimo provoz.",
    "text": "Pokud si myslíte, že to není správné, pošlete nám zprávu na ",
    "back_button": "Zpět na hlavní panel"
  },
  "typography": {
    "primary": "Primární textové styly",
    "secondary": "Sekundární textové styly"
  },
  "dashboard": {
    "versions": "Verze",
    "setupRemoteConnections": "Nastavení vzdálených připojení",
    "currentVisitors": "Aktuální návštěvníci",
    "navigationLayout": "rozložení navigace",
    "topBarButton": "Horní lišta",
    "sideBarButton": "Boční lišta"
  },
  "language": {
    "brazilian_portuguese": "Portugalština",
    "english": "Angličtina",
    "spanish": "Španělština",
    "simplified_chinese": "Zjednodušená čínština",
    "persian": "Perština"
  },
  "menu": {
    "auth": "Autorizace",
    "buttons": "Tlačítka",
    "timelines": "Časové osy",
    "dashboard": "Hlavní panel",
    "billing": "Fakturace",
    "login": "Přihlásit se",
    "preferences": "Předvolby účtu",
    "payments": "Platby",
    "settings": "Nastavení aplikace",
    "pricing-plans": "Cenové plány",
    "payment-methods": "Platební metody",
    "signup": "Zaregistrovat se",
    "recover-password": "Obnovit heslo",
    "recover-password-email": "Email pro obnovení hesla",
    "404": "404",
    "faq": "FAQ",
    "users": "Uživatelé",
    "projects": "Projekty",
    "faults": "Chybové hlášky",
    "battery": "Baterie",
    "home": "Domov",
    "profile": "Profil",
    "dashboard-settings": "Nastavení hlavního panelu",
    "scheduler": "Plánovač",
    "device-settings": "Nastavení zařízení",
    "alerts": "Upozornění",
    "active-devices": "Aktivní zařízení",
    "smart-meters": "Elektroměry"
  },
  "messages": {
    "all": "Zobrazit všechny zprávy",
    "new": "Nové zprávy od {name}",
    "mark_as_read": "Označit jako přečtené"
  },
  "navbar": {
    "messageUs": "Dotazy na vývoj webu:",
    "repository": "GitHub Rep"
  },
  "notifications": {
    "all": "Zobrazit všechny upozornění",
    "less": "Zobrazit méně upozornění",
    "mark_as_read": "Označit jako přečtené",
    "sentMessage": "vám poslal(a) zprávu",
    "uploadedZip": "nahrál(a) nový soubor typu Zip s {type}",
    "startedTopic": "zahájil(a) nové téma"
  },
  "user": {
    "language": "Změnit jazyk",
    "logout": "Odhlásit se",
    "profile": "Profil",
    "settings": "Nastavení",
    "billing": "Fakturace",
    "faq": "FAQ",
    "helpAndSupport": "Nápověda a podpora",
    "projects": "Projekty",
    "account": "Účet",
    "explore": "Prozkoumat"
  },
  "treeView": {
    "basic": "Základní",
    "icons": "Ikony",
    "selectable": "Vybratelné",
    "editable": "Editovatelné",
    "advanced": "Pokročilé"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Odeslat"
  },
  "spacingPlayground": {
    "value": "Hodnota",
    "margin": "Okraj",
    "padding": "Odsazení"
  },
  "spacing": {
    "title": "Rozestupy"
  },
  "cards": {
    "cards": "Karty",
    "fixed": "Pevné",
    "floating": "Plovoucí",
    "contentText": "Unikátní pruhy zeber z nich činí jedno z nejznámějších zvířat.",
    "contentTextLong": "Unikátní pruhy zeber z nich činí jedno z nejznámějších zvířat. Vyskytují se v různých biotopech, jako jsou savany, lesy, keřové porosty, hory a pobřežní kopce. Různé lidské aktivity měly závažný dopad na populace zeber, zejména lov pro kůži a ničení biotopů. Grévyho zebra a horská zebra jsou ohrožené. I když jsou zebry plání mnohem hojnější, jeden poddruh, quagga, vyhynul.",
    "rowHeight": "Výška řádku",
    "title": {
      "default": "Výchozí",
      "withControls": "S ovládacími prvky",
      "customHeader": "Vlastní záhlaví",
      "withoutHeader": "Bez záhlaví",
      "withImage": "S obrázkem",
      "withTitleOnImage": "S titulkem na obrázku",
      "withCustomTitleOnImage": "S vlastním titulkem na obrázku",
      "withStripe": "S pruhem",
      "withBackground": "S pozadím"
    },
    "button": {
      "main": "Hlavní",
      "cancel": "Zrušit",
      "showMore": "Zobrazit více",
      "readMore": "Přečíst více"
    },
    "link": {
      "edit": "Upravit",
      "setAsDefault": "Nastavit jako výchozí",
      "delete": "Smazat",
      "traveling": "Cestování",
      "france": "Francie",
      "review": "Recenze",
      "feedback": "Zanechat zpětnou vazbu",
      "readFull": "Přečíst celý článek",
      "secondaryAction": "Sekundární akce",
      "action1": "Akce 1",
      "action2": "Akce 2"
    }
  },
  "colors": {
    "themeColors": "Barvy tématu",
    "extraColors": "Extra barvy",
    "gradients": {
      "basic": {
        "title": "Gradienty tlačítek"
      },
      "hovered": {
        "title": "Hoverované gradienty tlačítek",
        "text": "Pro hover stav se aplikuje zesvětlení o 15 % původního stylu (gradient nebo plochá barva)."
      },
      "pressed": {
        "title": "Zmáčknuté gradienty tlačítek",
        "text": "Pro stisknutý stav se aplikuje ztmavení o 15 % původního stylu (gradient nebo plochá barva)."
      }
    }
  },
  "tabs": {
    "alignment": "Zarovnání záložek",
    "overflow": "Přetékání záložek",
    "hidden": "Záložky se skrytým posuvníkem",
    "grow": "Růst záložek"
  },
  "helpAndSupport": "Nápověda a podpora",
  "aboutVuesticAdmin": "O Vuestic Admin",
  "search": {
    "placeholder": "Hledat..."
  },
  "buttonSelect": {
    "dark": "Tmavý",
    "light": "Světlý"
  },
  "custom": {
    "language": "Jazyk",
    "turn_off_inverter": "Vypnout systém",
    "turn_on_inverter": "Zapnout systém",
    "regulation_active": "Vypnout regulaci",
    "regulation_inactive": "Zapnout regulaci",
    "min_max_regulation_active": "Vypnout Max/Min regulaci",
    "min_max_regulation_inactive": "Zapnout Max/Min regulaci",
    "emergency_stop": "Úplné zastavení",
    "force_battery_charge": "Nucené nabíjení baterie",
    "set_charge": "Zapnout nabíjení/vybíjení",
    "unset_charge": "Vypnout nabíjení/vybíjení",
    "actual_regulation_state": "Aktuální stav regulace",
    "actual_charge_state": "Aktuální stav nabíjení",
    "actual_regulation_value": "Aktuální hodnota regulace",
    "actual_calculated_regulation": "Aktuální vypočtená regulace",
    "actual_regulation_Max_Min_state": "Aktuální stav Max/Min regulace",
    "actual_regulation_Max_Min_value": "Aktuální hodnota Max/Min regulace",
    "total": "Celkem",
    "total_active_power": "Celkový aktivní výkon",
    "l1_active_power": "L1 aktivní výkon",
    "l2_active_power": "L2 aktivní výkon",
    "l3_active_power": "L3 aktivní výkon",
    "l1_voltage": "L1 napětí",
    "l2_voltage": "L2 napětí",
    "l3_voltage": "L3 napětí",
    "pt": "PT",
    "pa": "PA",
    "pb": "PB",
    "pc": "PC",
    "p1_current": "Fáze 1 proud",
    "p2_current": "Fáze 2 proud",
    "p3_current": "Fáze 3 proud",
    "pf": "Power Factor - účinník",
    "import_kwh": "Import",
    "export_kwh": "Export",
    "import_kvarh": "Import",
    "export_kvarh": "Export",
    "battery_1_soc": "Baterie 1 Nabití",
    "battery_2_soc": "Baterie 2 Nabití",
    "battery_3_soc": "Baterie 3 Nabití",
    "battery_4_soc": "Baterie 4 Nabití",
    "battery_5_soc": "Baterie 5 Nabití",
    "battery_6_soc": "Baterie 6 Nabití",
    "battery_7_soc": "Baterie 7 Nabití",
    "battery_8_soc": "Baterie 8 Nabití",
    "charts": "Grafy",
    "compound": "Areál",
    "current_per_phase": "Aktuální proud na fázi",
    "total_active_power_chart": "Graf celkového aktivního výkonu",
    "regulation_chart": "Graf regulace",
    "inverter_faults": "Chybové hlášky",
    "module_temperature": "Teplota modulu",
    "ambient_temperature": "Okolní teplota",
    "logout": "Odhlásit se",
    "last_update": "Poslední aktualizace",
    "loading_data": "Načítávání dat",
    "page_not_found": "Stránka nenalezena",
    "dont_have_account": "Nemáte účet?",
    "sign_up": "Vytvořte si účet",
    "password": "Heslo",
    "repeat_password": "Zopakujte heslo",
    "create_account": "Vytvořit účet",
    "login": "Přihláště se",
    "already_have": "Už máte účet?",
    "password_hint": "Heslo by mělo mít více než 8 znaků: písmena, aspoň jedno číslo a speciální znak.",
    "field_required": "Pole je povinné",
    "passwords_not_match": "Hesla se neshodují",
    "password_min_length": "Heslo by mělo mít více než 8 znaků",
    "password_one_letter": "Heslo by mělo obsahovat aspoň jedno písmeno",
    "password_one_number": "Heslo by mělo obsahovat aspoň jedno číslo",
    "password_one_special": "Heslo by mělo obsahovat aspoň jeden speciální znak",
    "email_invalid": "Email není platný",
    "unsaved_changes_form": "Máte neuložené změny. Opravdu chcete opustit tuto stránku?",
    "add_user": "Přidat uživatele",
    "edit_user": "Upravit uživatele",
    "add_irebox": "Přidat iRebox",
    "add": "Přidat",
    "edit": "Upravit",
    "save": "Uložit",
    "cancel": "Zrušit",
    "delete": "Smazat",
    "is_active": "Aktivní",
    "is_verified": "Ověřený",
    "is_superuser": "Administrátor",
    "is_dashboard_only": "Pouze hlavní panel",
    "ireboxes": "iReboxy",
    "hide": "Zavřít",
    "more_info": "Více informací",
    "delete_irebox": "Smazat iRebox",
    "delete_user": "Smazat uživatele",
    "delete_irebox_confirmation": "Opravdu chcete smazat iRebox {irebox} uživatele {user}?",
    "delete_user_confirmation": "Opravdu chcete smazat uživatele {user}?",
    "cannot_delete_yourself": "Nemůžete smazat sami sebe",
    "bms_data": "Dáta o Battery Management System",
    "battery_charging": "Baterie se nabíjí",
    "battery_discharging": "Baterie se vybíjí",
    "work_in_progress": "Pracujeme na tom",
    "battery_charge_total": "Celkové nabití baterie",
    "bms_soc_cumulative_chart": "Graf nabití baterií",
    "smart_meter_cumulative_chart": "Graf celkového výkonu a výkonu ve fázích",
    "total_active_power_cumulative_chart": "Graf celkového aktivního výkonu na střídači",
    "solar_power_cumulative_chart": "Graf solárního výkonu",
    "daily": "Den",
    "weekly": "Týden",
    "monthly": "Měsíc",
    "devices": "Zařízení",
    "search": "Hledat",
    "user_info": "Informace o uživateli",
    "edit_password": "Změnit heslo",
    "old_password": "Staré heslo",
    "new_password": "Nové heslo",
    "confirm_password": "Zopakujte nové heslo",
    "no_devices": "Žádná zařízení",
    "irebox_info": "Informace o zařízeních",
    "add_irebox_alias": "Přidat alias iReboxu",
    "delete_irebox_alias": "Smazat alias iReboxu",
    "delete_irebox_alias_confirmation": "Opravdu chcete smazat alias iReboxu {name}?",
    "back": "Zpět",
    "input_integer": "Zadejte celé číslo",
    "inputKW_invalid": "Zadejte platnou hodnotu v kW v rozsahu -500 až 500",
    "input4W_invalid": "Zadejte platnou hodnotu v W v rozsahu 0 až 200 000",
    "inputSoc_invalid": "Zadejte platnou hodnotu v % v rozsahu 20 až 100",
    "download": "Stáhnout",
    "download_format": "Stáhnout ve formátu",
    "custom": "Vlastní",
    "from": "Od",
    "to": "Do",
    "set": "Nastavit",
    "select_time_interval": "Vyberte časové rozmezí",
    "error_from_greater_than_to": "Hodnota Od musí být menší než Do",
    "bucket_size": "Velikost intervalu",
    "mode": "Režim",
    "smart_management": "Smart řízení",
    "conditioned_charging": "Kondiční nabíjení",
    "next_planned_conditioned_charging": "Další plánované kondiční nabíjení",
    "last_full_charge": "Poslední plné nabití",
    "idle": "Naplánováno",
    "running": "Probíhá",
    "max_charge": "Maximální nabíjení",
    "max_discharge": "Maximální vybíjení",
    "converter_power": "Výkon měniče",
    "start_datetime": "Datum a čas spuštění",
    "end_datetime": "Datum a čas ukončení",
    "turn_off": "Vypnout",
    "turn_on": "Zapnout",
    "current_state": "Aktuální stav",
    "status_overview": "Přehled stavu",
    "device_status": "Stav zařízení",
    "main_inverter_type": "Typ hlavního střídače",
    "no_issues_detected": "Nenalezeny žádné problémy",
    "issues_detected": "Nalezeny problémy - podpora byla upozorněna",
    "name": "Název",
    "widgets": "Widgety",
    "search_email": "Hledat email",
    "device_info": "Informace o zařízení",
    "notes": "Poznámky"
  },
  "control_mode": {
    "title": "Režim řízení baterie",
    "disabled": "Neaktivní",
    "disabled_discharge": "Zakázáno vybíjení baterie",
    "auto": "Auto",
    "forced_charge": "Manuální nabíjení baterie",
    "forced_discharge": "Manuální vybíjení baterie",
    "min_charge": "Minimální hodnota nabítí",
    "max_charge": "Maximální hodnota nabítí",
    "inverter_power": "Výkon střídače",
    "regulation": "Regulace",
    "regulation_power": "Výkon regulace",
    "min_max_regulation": "Min/Max regulace",
    "min_regulation_power": "Minimální hodnota regulace",
    "max_regulation_power": "Maximální hodnota regulace",
    "mode": "Režim",
    "min_less_than_max": "Minimální hodnota musí být menší než maximální hodnota"
  },
  "solar_regulation": {
    "title": "Režim solární výroby",
    "export_enabled": "Povolit přetok solární výroby do sítě",
    "export_limit": "Max. přetok do sítě",
    "state_export_enabled": "Aktuální stav",
    "actual_export_limit": "Aktualní hodnota exportu solární výroby do sítě"
  },
  "peak_shaving": {
    "title": "Režim peak shaving",
    "gen_enabled": "Aktualní stav GEN peak shavingu",
    "grid_enabled": "Aktualní stav GRID peak shavingu",
    "actual_gen_value": "Aktualní hodnota GEN peak shavingu",
    "actual_grid_value": "Aktualní hodnota GRID peak shavingu",
    "set_gen_value": "Hodnota GEN peak shavingu",
    "set_grid_value": "Hodnota GRID peak shavingu",
    "set_gen": "Nový stav GEN peak shavingu",
    "set_grid": "Nový stav GRID peak shavingu"
  },
  "powerflow": {
    "inverter_data": "Data střídače",
    "inverter_detail": "Detail střídače",
    "inverter": "Střídač"
  },
  "scheduler": {
    "new_plan": "Nový plán",
    "create_plan": "Vytvořit plán",
    "plan_details": "Detaily plánu",
    "event_overlaps": "Plán se překrývá s jinou událostí",
    "start": "Datum a čas spuštění",
    "end": "Datum a čas ukončení",
    "params": "Parametry",
    "event_updated": "Událost byla aktualizována",
    "event_update_error": "Nepodařilo se aktualizovat událost"
  },
  "management_picker": {
    "selected_mode": "Vybraný režim",
    "manual_control": "Manuální",
    "half_auto_control": "Poloautomatika (plánovač)",
    "auto_control": "Auto",
    "scheduler": "Plánovač"
  },
  "device_settings": {
    "device_settings": "Nastavení zařízení",
    "device_name": "Název zařízení",
    "inverter_type": "Typ střídače",
    "bms_type": "Typ BMS",
    "web_modules": "Webové moduly",
    "widgets": "Widgety",
    "email_alerts": "Emailové upozornění",
    "test_email_sent": "Testovací email byl odeslán",
    "settings": "Nastavení"
  },
  "charts": {
    "import_export_charts": "Grafy importu a exportu",
    "import_kwh": "Graf přírůstků importu v kWh",
    "export_kwh": "Graf přírůstků exportu v kWh",
    "import_kvarh": "Graf přírůstků importu v kVArh",
    "export_kvarh": "Graf přírůstků exportu v kVArh",
    "total_delta": "Celkový přírůstek za období",
    "last_value": "Hodnota na konci období"
  },
  "alerts": {
    "timestamp": "Čas",
    "module": "Modul",
    "public": "Veřejné",
    "kwargs": "Parametry",
    "resolved": "Vyřešeno",
    "all": "Zobrazit všechny",
    "unresolved_only": "Pouze nevyřešené",
    "resolve": "Vyřešit"
  },
  "error_messages": {
    "fetch_users": "Nepodařilo se načíst uživatele",
    "modify_user": "Nepodařilo se upravit uživatele, kod chyby: {error}"
  },
  "bms_settings": {
    "title": "Nastavení BMS",
    "cell": "Článek",
    "temperature": "Teplota",
    "voltage": "Napětí",
    "current": "Proud",
    "cell_voltage_parameters": "Napětí článků",
    "temperature_parameters": "Teploty článků",
    "system_parameters": "Systémové parametry",
    "acquisition_parameters": "Parametry snímání",
    "Cell Voltage Parameters": "Napětí článků",
    "Temperature Parameters": "Teploty článků",
    "System Parameters": "Systémové parametry",
    "Acquisition Parameters": "Parametry snímání",
    "actual_data": "Aktuální data",
    "sensor": "Senzor"
  },
  "smart_meters": {
    "title": "Elektroměry",
    "last_update": "Poslední aktualizace",
    "power": "Výkon",
    "voltage": "Napětí",
    "current": "Proud",
    "frequency": "Frekvence",
    "active_energy": "Činná energie",
    "reactive_energy": "Jalová energie",
    "import_active_energy": "Import aktivní energie",
    "export_active_energy": "Export aktivní energie",
    "import_reactive_energy": "Import reaktivní energie",
    "export_reactive_energy": "Export reaktivní energie",
    "pf": "Účinník",
    "loading_data": "Načítávání dat",
    "refresh_data": "Obnovit data",
    "change_name": "Změnit název",
    "name": "Název",
    "new_name": "Nový název",
    "detail": {
      "title": "Detail elektroměru",
      "energy_since_reset": "Energie od resetu",
      "since": "Od:",
      "never_reset": "Počítadlo nebylo vynulováno",
      "phases": "Hodnoty po fázích",
      "meter_value": "Elektroměr"
    },
    "reset": {
      "button": "Vynulovat počítadlo",
      "confirm_text": "Počítadlo energie v iReboxu se nastaví na 0. Samotný elektroměr se nemění.",
      "note": "Poznámka (volitelné)",
      "confirm": "Vynulovat",
      "success": "Počítadlo bylo vynulováno"
    },
    "export": {
      "button": "Export",
      "title": "Export minutových dat",
      "mode_range": "Zvolené období",
      "mode_last_reset": "Od posledního resetu",
      "format": "Formát",
      "max_range": "Maximální rozsah je {days} dní.",
      "download": "Stáhnout",
      "in_progress": "Probíhá příprava souboru, může to trvat několik sekund…"
    },
    "history": {
      "title": "Historie resetů",
      "reset_at": "Čas resetu",
      "note": "Poznámka",
      "import_base": "Import elektroměru při resetu",
      "export_base": "Export elektroměru při resetu",
      "export_test": "Exportovat tento test",
      "empty": "Počítadlo zatím nebylo vynulováno"
    },
    "errors": {
      "forbidden": "K tomuto iReboxu nemáte přístup.",
      "not_found": "iRebox nebo elektroměr nebyl nalezen.",
      "generic": "Požadavek se nezdařil."
    }
  }
}
